<template>
  <div class="item_wrap " :class="session.gameState == -1?'gay':session.peopleNum > 0?'wait':''"
       :style="'height: ' + session.len + 'px'" >
    <div class="time">{{session.startTimeStr}}-{{session.endTimeStr}}</div>
    <!-- 超过时间 -->
    <template v-if="session.gameState == -1">
      <!--            <div class="text">已有{{session.peopleNum }}人</div>-->
      <!--            <div class="gay"></div>-->
    </template>
    <!-- 未开始 -->
    <template v-else-if="session.gameState == 0">
      <!-- 满场 -->
      <template v-if="session.peopleNum >= session.playerMax || session.tags == 1">
        <div class="text">已有{{session.peopleNum }}人</div>
        <div class="closed"></div>
        <div class="man">满</div>
      </template>
      <!-- 未满场有人 -->
      <template v-else-if="session.peopleNum > 0" >
        <div class="text">已有{{session.peopleNum }}人 可加入{{session.playerMax - session.peopleNum }}人</div>
      </template>
      <!-- 未满场0人 -->
      <template v-else >
        <div class="text">可预约</div>
      </template>
    </template>
    <template v-else >
      <div class="text">已有{{session.peopleNum }}人</div>
      <div class="closed"></div>
      <div class="gaming">游戏中</div>
    </template>
  </div>
</template>

<script>
export default {
  name: "itemUrx",
  props: {
    session:{
      type: null,
      default: null
    },
  },
  data() {
    return {
    }
  },
  methods: {

  }
}
</script>

<style scoped>
.wait{
  background: #fff000!important;
}
.gay{
  background: #d6d6d6 !important;
}
.closed{
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(47, 0, 210, 0.7);
}
.gaming{
  position: absolute;
  width: 97px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 22px;
  border: 2px solid #ff439f;
  font-weight: 800;
  color: #ff439f;
  font-size: 24px;
}
.man{
  position: absolute;
  right: 15px;
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 2px solid #ff439f;
  font-weight: 800;
  color: #ff439f;
  font-size: 30px;
  transform: rotate(-15deg);
}
.item_wrap{
  position: relative;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 800;
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: #1dee7c;
  overflow: hidden;
}
.time{
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  font-size: 22px;
}
.text{
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
